import React from "react";
import AuditStrikeZoneFooterButtons from "../common/AuditFooterButtons";

class AuditStrikeZoneActions extends React.Component {
  render() {
    return (
      <div className="row">
        <div className="col-12">
          <AuditStrikeZoneFooterButtons />
        </div>
      </div>
    );
  }
}

export default AuditStrikeZoneActions;
